export const getResendDeadline = (timeToNextTry) => {
  if (!timeToNextTry) return null

  const parsedDate = new Date(timeToNextTry).getTime()
  return Number.isNaN(parsedDate) ? null : parsedDate
}
